import alertCircle from "./icons/alertCircle.js";
import angleDown from "./icons/angleDown.js";
import arrowDown from "./icons/arrowDown.js";
import arrowLeft from "./icons/arrowLeft.js";
import arrowRight from "./icons/arrowRight.js";
import arrowUp from "./icons/arrowUp.js";
import check from "./icons/check.js";
import chevronDown from "./icons/chevronDown.js";
import chevronLeft from "./icons/chevronLeft.js";
import chevronRight from "./icons/chevronRight.js";
import close from "./icons/close.js";
import creditCard from "./icons/creditCard.js";
import download from "./icons/download";
import edit from "./icons/edit";
import eye from "./icons/eye.js";
import eyeSlash from "./icons/eyeSlash.js";
import facebook from "./icons/facebook.js";
import file from "./icons/file.js";
import fileText from "./icons/fileText.js";
import google from "./icons/google.js";
import information from "./icons/information.js";
import linkedin from "./icons/linkedin.js";
import lock from "./icons/lock.js";
import mail from "./icons/mail.js";
import menu from "./icons/menu.js";
import onboardingArrow from "./icons/onboardingArrow.js";
import phone from "./icons/phone.js";
import settings from "./icons/settings.js";
import user from "./icons/user.js";
import x from "./icons/x.js";
import star from "./icons/star.js";
import male from "./icons/male.js";
import female from "./icons/female.js";
import home from "./icons/home.js";

// Braingineers Icons
import add from "./icons/add.js";
import allTests from "./icons/allTests.js";
import brainrocket from "./icons/brainrocket.js";
import benchmark from "./icons/benchmark.js";
import department from "./icons/department.js";
import company from "./icons/company.js";
import support from "./icons/support.js";
import journey from "./icons/journey.js";
import exportPdf from "./icons/exportPDF.js";
import members from "./icons/members.js";
import account from "./icons/account.js";
import overview from "./icons/overview.js";
import pageInsights from "./icons/pageInsights.js";
import videos from "./icons/videos.js";
import elements from "./icons/elements.js";
import professional from "./icons/professional.js";
import journeyinsights from "./icons/journeyinsights.js";
import targetGroupCustom from "./icons/targetGroupCustom.js";
import targetGroup from "./icons/targetGroup.js";
import muscleBrain from "./icons/muscleBrain.js";
import trashcan from "./icons/delete.js";
import info from "./icons/info.js";
import research from "./icons/research.js";
import brain from "./icons/brain.js";
import eyeTracking from "./icons/eyeTracking.js";
import mousePointer from "./icons/mousePointer.js";
import plus from "./icons/plus.js";
import pencil from "./icons/pencil.js";
import chevronDownNew from "./icons/chevronDownNew.js";
import closeTag from "./icons/closeTag.js";
import fbold from "./icons/f-bold.js";
import fcheck from "./icons/f-check.js";
import fupload from "./icons/f-upload.js";
import fdelete from "./icons/f-delete.js";
import fplus from "./icons/f-plus.js";
import fitalic from "./icons/f-italic.js";
import flist from "./icons/f-list.js";
import fredo from "./icons/f-redo.js";
import funderline from "./icons/f-underline.js";
import fundo from "./icons/f-undo.js";
import fview from "./icons/f-view.js";
import fmouse from "./icons/f-mouse.js";
import fedit from "./icons/f-edit.js";
import book from "./icons/book.js";
import image from "./icons/image.js";
import link from "./icons/link.js";
import circle from "./icons/circle.js";
import checkCircle from "./icons/check-circle.js";
import search from "./icons/search.js";
import copy from "./icons/copy.js";
import save from "./icons/save.js";
import trash from "./icons/trash.js";
import minimize from "./icons/minimze.js";

export default {
  minimize,
  trash,
  save,
  circle,
  checkCircle,
  copy,
  search,
  link,
  image,
  book,
  add,
  info,
  fbold,
  fcheck,
  fupload,
  fdelete,
  fplus,
  fitalic,
  flist,
  fview,
  fmouse,
  fredo,
  funderline,
  fundo,
  fedit,
  fview,
  support,
  muscleBrain,
  allTests,
  trashcan,
  targetGroupCustom,
  targetGroup,
  brainrocket,
  account,
  benchmark,
  journeyinsights,
  professional,
  department,
  elements,
  company,
  journey,
  exportPdf,
  members,
  overview,
  pageInsights,
  videos,
  alertCircle,
  angleDown,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  check,
  chevronDown,
  chevronLeft,
  chevronRight,
  close,
  creditCard,
  download,
  edit,
  eye,
  eyeSlash,
  facebook,
  file,
  fileText,
  google,
  home,
  information,
  linkedin,
  lock,
  mail,
  menu,
  onboardingArrow,
  phone,
  settings,
  user,
  x,
  star,
  male,
  female,
  research,
  brain,
  eyeTracking,
  mousePointer,
  plus,
  pencil,
  chevronDownNew,
  closeTag,
};
